export {
  DAY_NAMES_UPPER as dayNamesUpper,
  WORK_TYPE_OPTIONS,
} from "@/features/shared";

export const PROJECT_DAILY_REPORT_FILTER_PARAMS = [
  "projectId",
  "customerId",
  "dateRange",
  "startDate",
  "endDate",
  "search",
  "sortBy",
  "orderBy",
  "projectType",
];

export const projectDailyReportApiRoutes = {
  dailyReports: "workspace/:workspace/report/daily",
  dailyReportById: "workspace/:workspace/report/daily/:id",
  dailyReportTaskBreakdown: "workspace/:workspace/report/daily/task-breakdown",
  projectTippingRecords:
    "workspace/:workspace/report/project/:projectId/tipping-records",
};

export const PROJECT_DAILY_REPORT_SHIFT_TITLES = {
  NORMAL_HOURS: "Normal Hours",
  OVERNIGHT_HOURS: "Overnight Hours",
  WEEKEND: "Weekend",
} as const;

export const PROJECT_DAILY_REPORT_SHIFT_IDS = {
  NORMAL: "normal",
  OVERNIGHT: "overnight",
  WEEKEND: "weekend",
} as const;

export const PROJECT_DAILY_REPORT_SHIFT_ORDER = [
  PROJECT_DAILY_REPORT_SHIFT_TITLES.NORMAL_HOURS,
  PROJECT_DAILY_REPORT_SHIFT_TITLES.OVERNIGHT_HOURS,
  PROJECT_DAILY_REPORT_SHIFT_TITLES.WEEKEND,
] as const;
